module.exports = __webpack_public_path__ + "img/JO.8fa47fe7.svg";